function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_378",
  "data-name": "Path 378",
  d: "M15,8a1,1,0,0,1-1-1V3a1,1,0,0,0-1-1H3A1,1,0,0,0,2,3V13a1,1,0,0,0,1,1H5a1,1,0,0,1,0,2H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H13a3,3,0,0,1,3,3V7A1,1,0,0,1,15,8Z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_379",
  "data-name": "Path 379",
  d: "M8,15l5-5,2,2",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  fillRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_380",
  "data-name": "Path 380",
  d: "M7,10a3,3,0,1,1,3-3A3,3,0,0,1,7,10ZM7,6A1,1,0,1,0,8,7,1,1,0,0,0,7,6Z",
  fill: "#fff",
  fillRule: "evenodd"
});

function SvgImgPlace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_65641",
    "data-name": "Group 65641",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.414,
    height: 16.414,
    viewBox: "0 0 16.414 16.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgPlace);
export default __webpack_public_path__ + "static/media/imgPlace.5916f148.svg";
export { ForwardRef as ReactComponent };